export default "__VITE_ASSET__i2oCo3vl__"